import cEditLink from '#themes/default/default/components/editLink/editLink.js';

import template from './companySummary.html' with { type: 'html' };

export default {
	name: 'CCompanySummary',
	components: {
		cEditLink
	},
	props: {
		ariaDescribeId: {
			type: String,
			default: null
		},
		customer: {
			type: Object,
			default: () => null
		},
		form: {
			type: Object,
			default: () => null
		},
		isThankYouPage: {
			type: Boolean,
			default: false
		},
		order: {
			type: Object,
			default: () => null
		},
		page: {
			type: Object,
			default: () => null
		},
		theme: {
			type: Object,
			default: () => null
		},
		url: {
			type: Object,
			default: () => null
		}
	},
	template
};
